import { Icon } from "armstrong-react";
import React from "react";
import { IToolbarProps } from ".";
import { DropdownButton } from "../../../../core/atoms/atoms";
import { PriceCalculator } from "../../currency/priceCalculator";
import * as SlateUtils from "../slateUtils";

import "./togglePriceCalculatorButton.scss";

export const TogglePriceCalculatorButton = ({ editorRef }: IToolbarProps) => {
  // TODO - this functionality should probably live in a plugin.
  const priceInsert = (priceString: string) => {
    if (!editorRef) {
      return;
    }

    // * selecting all text by mouse drag and deleting unsets the selection
    // * error with slate.js you cannot insert into a null path - https://github.com/ianstormtaylor/slate/issues/2942
    if (editorRef.value.selection.isUnset) {
      const { key } = editorRef.value.document.getFirstText();
      const range = SlateUtils.generateRange(key);

      // * Weird hackery to get content to insert into editor at start of document
      (editorRef as any)
        .setEnd(range.point)
        .insertTextAtRange(range.range, ` ${priceString} `);
    }
    else {
      editorRef.insertText(` ${priceString} `).focus();
    }
  };

  return (
    <div className="slate-toolbar-dropdown">
      <DropdownButton
        buttonClassName="slate-toolbar-button"
        icomoon={Icon.Icomoon.calculator}
        label="Price Calculator"
        renderDropdown={closeDropdown => (
          <PriceCalculator insertPrice={priceInsert} onInsert={closeDropdown} />
        )}
      />
    </div>
  );
};
